import { pickBy } from 'shared/utils/misc';
import { parseQueryString } from './misc';
export class ParsedURL {
    constructor(url = window.location.href, skipParamEncoding = false) {
        this.spaceEncoding = '%20';
        this.skipParamEncoding = false;
        /**
         * Update the query parameters. If a parameter already exists, it will not be updated.
         */
        this.mergeUndefinedParams = (params) => {
            const currentKeys = Object.keys(this.queryParams);
            const newParams = pickBy((_, key) => !currentKeys.includes(key), params);
            this.queryParams = Object.assign(Object.assign({}, this.queryParams), newParams);
            return this;
        };
        /**
         * Get a single query parameter value.
         */
        this.queryParam = (key) => this.queryParams[key];
        /**
         * Get the full URL including query parameters, hash, etc.
         */
        this.href = () => {
            const base = `${this.protocol}//${this.host}${this.pathname}`;
            const queryParamString = this.queryParamsToSearchString();
            return `${base}${queryParamString}${this.hash}`;
        };
        /**
         * Parse a URL search string into key-value pairs.
         */
        this.queryParamsOfSearchString = (urlOrSearchString) => {
            // Only works with `skipParamEncoding` is set to `false`.
            // If the URL contains a '+' character, switch to '+' as space encoding.
            if (urlOrSearchString.includes('+')) {
                this.spaceEncoding = '+';
            }
            return parseQueryString(urlOrSearchString, false, this.skipParamEncoding);
        };
        /**
         * Encode query param key-value pairs into a URL search string.
         */
        this.queryParamsToSearchString = () => {
            const paramArray = Object.keys(this.queryParams);
            if (paramArray.length === 0) {
                return '';
            }
            const paramString = paramArray
                .map(key => this.queryParamToSearchPiece(key, this.queryParams[key]))
                .join('&');
            return '?' + paramString;
        };
        /**
         * Convert a query param and its value to a search string piece.
         * Works when it's value is either a single value or array of values.
         */
        this.queryParamToSearchPiece = (key, valueOrValues) => Array.isArray(valueOrValues)
            ? valueOrValues
                .map(value => this.buildSingleValue(key, value))
                .join('&')
            : this.buildSingleValue(key, valueOrValues);
        /**
         * Convert a single query param and single value to a search string piece.
         */
        this.buildSingleValue = (key, value) => {
            // as-is, no encoding, no use of `this.spaceEncoding`
            if (this.skipParamEncoding) {
                return [key, value].join('=');
            }
            return [encodeURIComponent(key), encodeURIComponent(value)]
                .map(v => (this.spaceEncoding === '+' ? v.replace(/%20/g, '+') : v))
                .join('=');
        };
        var parser = document.createElement('a');
        parser.href = url;
        // copies all the properties to this object
        ['host', 'hostname', 'hash', 'port', 'protocol'].forEach(
        // @ts-expect-error - dynamic assign property
        prop => (this[prop] = parser[prop]));
        // record if param decoding is skipped
        this.skipParamEncoding = skipParamEncoding;
        // Parse a URL search string into key-value pairs.
        this.queryParams = this.queryParamsOfSearchString(parser.search);
        // pathname is special because IE takes the "/" off the starting of pathname
        this.pathname =
            (parser.pathname.charAt(0) !== '/' ? '/' : '') + parser.pathname;
    }
}
/**
 * Create and return a ParsedURL instance.
 */
ParsedURL.of = (url, skipParamEncoding) => new ParsedURL(url, skipParamEncoding);
